import { ApolloClient } from 'apollo-client';
import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
  defaultDataIdFromObject,
} from 'apollo-cache-inmemory';
import { toIdValue } from 'apollo-utilities';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { from } from 'apollo-link';
// import { createPersistedQueryLink } from 'apollo-link-persisted-queries';
import log from 'loglevel';

import getConfig from '../Util/Config';

// import persistedQueryLink from './persistedQueryLink';
import firebase from '../Firebase';

import introspectionQueryResultData from './fragmentTypes.json';

const apolloPath = getConfig().graphApi;

const httpLink = new HttpLink({
  uri: apolloPath,
  credentials: 'include',
  // credentials: 'same-origin',
});

const authLink = setContext(async () => {
  const currentUser = firebase.auth().currentUser;

  if (currentUser) {
    try {
      const token = await currentUser.getIdToken(false);
      return {
        headers: {
          Authorization: token,
        },
      };
    } catch (error) {
      throw new Error(error);
    }
  } else {
    console.error('no token');
    throw new Error('No token');
  }
});

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

const cache = new InMemoryCache({
  fragmentMatcher,
  cacheRedirects: {
    Query: {
      department: (_, args) =>
        toIdValue(cache.config.dataIdFromObject({ __typename: 'Department', id: args.id })),
      admissionRound: (_, args) =>
        toIdValue(cache.config.dataIdFromObject({ __typename: 'AdmissionRound', id: args.id })),
    },
  },
  dataIdFromObject: object => {
    switch (object.__typename) {
      default:
        return defaultDataIdFromObject(object); // fall back to default handling
    }
  },
});

const client = new ApolloClient({
  link: from([authLink, httpLink]),
  cache,
});

log.debug('graphql init with', apolloPath);

export default client;
